var jade = require("/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div ng-if=\"vm.updateAvailable\" class=\"row\"><div class=\"col-lg-12\"><div role=\"alert\" class=\"alert alert-warning\"><span class=\"glyphicon glyphicon-warning\">&nbsp;</span><span>Eine neue Version der Anwendung ist verfügbar: <a href=\"/\" target=\"_self\">Anwendung aktualisieren</a>.</span></div></div></div>");;return buf.join("");
}